<section class="bg-grey">
  <h1 class="os-blue-800">Pharmacy Registration</h1>
  <p class="section-copy mb-4">
    <span class="callout os-blue-300">Register now</span> to connect, negotiate
    and purchase product from Outsourcing Facilities. The secure process is
    quick and hassle free
  </p>
  <app-static-footer></app-static-footer>
  <h2 class="os-blue-300 mt-4">Questions?</h2>
  <h3>
    Contact us at <span class="os-blue-400">844-733-5633</span> or
    <span class="os-blue-400">info"&#64;503B.com</span>
  </h3>
</section>
